// extracted by mini-css-extract-plugin
export default {"container":"DocSummaryCard_container__iVykA"};